import React, { useState, useEffect } from "react";
import _ from "lodash";

//Assets
import PrevArrow from "assets/prev-arrow-white.png";
import NextArrow from "assets/next-arrow-white.png";
import XIcon from "assets/x-white.png";

function ModalImages({ detailImages, setIsOpenModalImages }) {
  const [position, setPosition] = useState(1);
  const [img, setImg] = useState({});
  
  const renderImage = () => {
    if (detailImages?.length) {
      const img = detailImages.filter((img, idx) => idx === position);
      if (img?.length) {
        setImg(img[0]);
      }
    } else {
      setImg("");
    }
  };

  const handlePrevImg = () => {
    let newPosition = position;
    if (newPosition > 1) {
      newPosition = newPosition - 1;
    }
    setPosition(newPosition);
  };

  const handleNextImg = () => {
    let newPosition = position;
    if (newPosition < detailImages?.length) {
      newPosition = newPosition + 1;
    }
    setPosition(newPosition);
  };

  useEffect(() => {
    renderImage();
  }, [position]);

  return (
    <div className="fixed z-[43] top-0 left-0 w-screen h-screen bg-[#101010] flex flex-col justify-center items-center z-40">
      <div className="w-screen h-screen bg-[#101010] flex flex-col justify-center items-center relative">
        <div
          className="absolute top-[60px] left-[54px] cursor-pointer flex items-center"
          onClick={() => setIsOpenModalImages(false)}
        >
          <img className="w-6 h-6 mr-4" src={XIcon} alt="x" /> <span className="font-inter font-semibold text-base leading-6 text-white">Tutup</span>
        </div>

        <p className="font-inter font-semibold text-base leading-6 text-white mb-12">
          {position}/{detailImages?.length}
        </p>
        <div className="flex items-center px-12 w-full justify-between">
          <img
            onClick={handlePrevImg}
            src={PrevArrow}
            alt="prev-arrow"
            className="w-8 h-8 object-contain cursor-pointer"
          />
          <div className="w-[976.75px] h-[651.17px] object-contain flex justify-center items-center">
            <img src={_.get(img, "image.url") || ""} alt="..." className="w-full h-full object-contain" />
          </div>
          <img
            onClick={handleNextImg}
            src={NextArrow}
            alt="next-arrow"
            className="w-8 h-8 object-contain cursor-pointer"
          />
        </div>
        <p className="font-inter font-semibold text-base leading-6 text-white">{_.get(img, "name") || ""}</p>
      </div>
    </div>
  );
}

export default ModalImages;
